import { type ThemeOptions } from '@mui/material';

export function createTableCellStyles() {
  return {
    MuiTableCell: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderBottom: `1px solid ${theme.palette.divider}`,
        }),
      },
    },
  } as ThemeOptions['components'];
}
